import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import bugsnagHandler from '../../../services/bugsnag.service';

export enum InsightType {
  Profits = 'profits',
  Expenses = 'expenses',
  Income = 'incomes'
}
export const fetchInsightsByType = async ({ queryKey }: { queryKey: any }) => {
  const [, {
    customerId,
    periodType,
    startTime,
    insightType,
  }] = queryKey;
  if (!customerId || !periodType || !startTime || !insightType) {
    bugsnagHandler.notify(`FetchInsightsByType missing props: customerId: ${customerId} , periodType: ${periodType}, startTime: ${startTime}, insightType: ${insightType}`);
    throw new Error('FetchInsightsByType missing props');
  } else {
    return httpService.get(`${BASE_URL}/api/v1/user/${customerId}/dashboard/${insightType}?periodType=${periodType.toUpperCase()}&startTime=${startTime}`);
  }
};

export const fetchNewInsightsByType = async (customerId: string, periodType: string, startTime: string, insightType: string) => {
  if (!customerId || !periodType || !startTime || !insightType) {
    throw new Error('FetchInsightsByType missing props');
  } else {
    return httpService.get(`${BASE_URL}/api/v1/user/${customerId}/dashboard/${insightType}?periodType=${periodType.toUpperCase()}&startTime=${startTime}`);
  }
};
